import axios from 'axios';

const API_BASE = '/api/dashboard';

export const getDashboardStats = async () => {
  const response = await axios.get(`${API_BASE}/stats`);
  return response.data;
};

export const getAttendanceTrends = async (days = 7) => {
  const response = await axios.get(`${API_BASE}/attendance-trends?days=${days}`);
  return response.data;
};

export const getGradeDistribution = async () => {
  const response = await axios.get(`${API_BASE}/grade-distribution`);
  return response.data;
};

export const getGenderDistribution = async () => {
  const response = await axios.get(`${API_BASE}/gender-distribution`);
  return response.data;
};

export const getFeeCollection = async () => {
  const response = await axios.get(`${API_BASE}/fee-collection`);
  return response.data;
};

export const getLeaveStats = async () => {
  const response = await axios.get(`${API_BASE}/leave-stats`);
  return response.data;
};

export const getWaitlistSummary = async () => {
  const response = await axios.get('/api/enrollments/waitlist/summary');
  return response.data;
};

export const getWaitlistEnrollments = async (gradeId = null) => {
  const params = gradeId ? `?grade_id=${gradeId}` : '';
  const response = await axios.get(`/api/enrollments/waitlist${params}`);
  return response.data;
};
